import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { PodSessionByType } from "../graphql/queries";
import {
  Box,
  Text,
  DataTable,
  Button,
  TextInput,
  Spinner,
  Data,
  Toolbar,
  DataSearch,
  DataFilters,
  DataSummary,
  Heading,
} from "grommet";
import { onLitePodSessionCreate } from "../graphql/subscriptions";
import { PodBookmarksViewer } from "../Components/PodBookmarks";

const columns = [
  {
    property: "testerName",
    header: <Text>Tester Name</Text>,
    render: (datum) => (
      <Box direction="row">
        <Text size="small" truncate>
          {datum.testerName}
        </Text>
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "medium",
  },
  {
    property: "testerEmail",
    header: <Text>Tester Email</Text>,
    render: (datum) => (
      <Box direction="row">
        <Text size="small" truncate>
          {datum.testerEmail}
        </Text>
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "medium",
  },
  {
    property: "actions",
    header: <Text>Actions</Text>,
    render: (datum) => (
      <Box direction="row">
        <Button
          label="View Session"
          size="small"
          primary
          onClick={() => window.open(`/pod-session?id=${datum.id}`, "_blank")}
        />
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "small",
  },
];

export default function Pod() {
  const [podSessions, setPodSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showBookmarks, setShowBookmarks] = useState(false);

  useEffect(() => {
    const fetchAllPodSessions = async () => {
      setLoading(true);
      let allSessions = [];
      let token = null;
      let refetches = 0;

      try {
        do {
          console.log(refetches);
          const { data } = await API.graphql({
            query: PodSessionByType,
            variables: {
              type: "PodSession",
              sortDirection: "DESC",
              nextToken: token,
              limit: 300,
            },
          });

          const newSessions = data.podSessionByType.items;
          token = data.podSessionByType.nextToken;
          allSessions = [...allSessions, ...newSessions];
          setPodSessions(allSessions);
          refetches++;
        } while (token && refetches < 4);
      } catch (err) {
        console.error("Error fetching pod sessions:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllPodSessions();
  }, []);

  useEffect(() => {
    const subscription = API.graphql({
      query: onLitePodSessionCreate,
      variables: {
        type: "PodSession",
      },
    }).subscribe({
      next: (data) => {
        if (!loading) {
          console.log(
            "New pod session",
            data.value.data.onLitePodSessionCreate
          );
          setPodSessions((podSessions) => [
            data.value.data.onLitePodSessionCreate,
            ...podSessions,
          ]);
        }
      },
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Box fill={true} pad="medium">
      <Box
        direction="row"
        justify="between"
        align="center"
        margin={{ bottom: "medium" }}
      >
        <Box
          background="status-ok"
          pad="xsmall"
          width="large"
          round="small"
          border={{ side: "left", color: "status-ok", size: "medium" }}
          textAlign="center"
          align="center"
          justify="center"
        >
          <Text size="small" textAlign="center" color="black">
            New sessions will now automatically populate the table, you may
            refresh less often.
          </Text>
        </Box>
        <Button
          label="View Bookmarked Sessions"
          primary
          onClick={() => setShowBookmarks(true)}
        />
      </Box>
      <Data
        data={podSessions}
        properties={{
          id: {
            label: "ID",
            property: "id",
            filter: false,
            search: false,
          },
          testerName: {
            label: "Tester Name",
            property: "testerName",
            filter: false,
          },
          testerEmail: {
            label: "Tester Email",
            property: "testerEmail",
            filter: false,
          },
          organizationName: {
            label: "Organization Name",
            property: "organizationName",
            filter: true,
          },
        }}
      >
        <Toolbar>
          <DataSearch placeholder="Search" />
          <DataFilters layer />
          <DataSummary />
        </Toolbar>
        <DataTable columns={columns} primaryKey="id" />
      </Data>
      <PodBookmarksViewer
        isOpen={showBookmarks}
        onClose={() => setShowBookmarks(false)}
      />
    </Box>
  );
}
